import { ArsContextState, IArsActionSetSidebarAnalysisMethodId } from "../interface";

/**
 * Sets the selected sidebar analysis method when it exists in state.
 *
 * @param state - Current ARS context state
 * @param action - Set-sidebar-analysis-method action
 * @returns Updated state, or the original state when the method is not known
 */
export const arsc_setSidebarAnalysisMethodId = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetSidebarAnalysisMethodId,
): ArsContextState<T> => {
  if (
    action.analysisMethodId &&
    !Object.keys(state.analysisMethods).includes(action.analysisMethodId)
  ) {
    return state;
  }

  return {
    ...state,
    currentSidebar: {
      ...state.currentSidebar,
      analysisMethodId: action.analysisMethodId,
    },
  };
};
